export default __webpack_public_path__ + "elevation-800-dd4103bf60785e6fbec057e6ad0c0258.png";